module.exports = __webpack_public_path__ + "img/img-2-4.6c5129ca.png";